import ViewReport from '../components/ViewReport';

export default ViewReport;
